export default __webpack_public_path__ + "static/media/matt.816178e4.jpg";